import { useState } from "react";

import { useNavigate, useSearchState } from "common/router/hooks";
import { EMAIL_REGEX } from "common/constants/regex";

import Form from "client/common/components/forms/Form";
import Button from "client/common/components/buttons/Button";
import TextButton from "client/common/components/buttons/TextButton";
import TextInput from "client/common/components/inputs/TextInput";
import FetchErrorAlert from "client/common/components/errors/FetchErrorAlert";
import { useProfileLookupMutation } from "client/accounts/hooks";
import { IProfileLookupResult } from "client/accounts/types";
import { Paths, urls } from "client/routes";

import AccountCreationLegalDisclaimer from "./AccountCreationDisclaimer";

import styles from "../../styles/EmailLookupForm.module.less";

type PhoneNumberLookupFormProps = {
  onSuccess: (result: IProfileLookupResult) => void;
  initialValue?: string;
};

const EmailLookupForm = (props: PhoneNumberLookupFormProps) => {
  const navigate = useNavigate();
  const { onSuccess, initialValue } = props;

  const [value, setValue] = useState(initialValue || "");

  const isEmail = !!value.match(EMAIL_REGEX);

  const {
    mutate: lookupProfile,
    isPending: isLookingUp,
    isSuccess: isLookupSuccess,
    error: lookupError,
  } = useProfileLookupMutation({
    onSuccess,
  });

  const canSubmit = isEmail && !(isLookingUp || isLookupSuccess);
  const isSubmitting = isLookingUp || isLookupSuccess;
  const onSubmit = () => {
    lookupProfile({ email: value, check_sms: false });
  };

  const [search] = useSearchState<Paths["accounts"]["lookup"]>({});

  return (
    <Form className={styles.form} canSubmit={canSubmit} onSubmit={onSubmit}>
      {lookupError && <FetchErrorAlert error={lookupError} />}
      <TextInput
        label="Email"
        value={value}
        onChange={setValue}
        errors={lookupError?.errors.email}
      />
      <Button disabled={!canSubmit} isLoading={isSubmitting} type="submit">
        Next
      </Button>
      <div className={styles.help}>
        Click{" "}
        <TextButton
          hasUnderline={true}
          onClick={() => {
            navigate(urls.accounts.lookup({ search: { ...search, method: "phone" } }));
          }}
        >
          here
        </TextButton>{" "}
        to instead look up an account by phone.
      </div>
      <AccountCreationLegalDisclaimer textAlign="center" />
    </Form>
  );
};

export default EmailLookupForm;
